import { render, staticRenderFns } from "./EventOverviewRow.vue?vue&type=template&id=015bb4fc"
import script from "./EventOverviewRow.vue?vue&type=script&lang=js"
export * from "./EventOverviewRow.vue?vue&type=script&lang=js"
import style0 from "./EventOverviewRow.vue?vue&type=style&index=0&id=015bb4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports